import CheckoutServicesV2 from '@websky/core/src/Checkout/components/Checkout/ServicesV2/ServicesV2';
import CheckinServicesV2 from '@websky/core/src/Modules/Checkin/components/Checkin/AdditionalServices/AdditionalServices';
export const renders = {
    CheckoutServices: CheckoutServicesV2,
    CheckinServices: CheckinServicesV2
};
